import React from "react";
import {Spinner as BootstrapSpinner} from "react-bootstrap";

import '../../../assets/sass/components/spinner/circular-spinner.scss';

export const CircularSpinner = props => <BootstrapSpinner className="circular-spinner" animation="border" variant="primary"/>;
